import { CatalogProgressTextInputComponent } from './catalog-progress-text-input.component';

/**
 * 企画進捗管理テキストインプットManageクラス
 *
 * @export CatalogProgressTextInputModel
 * @class CatalogProgressTextInputModel
 */
export class CatalogProgressTextInputModel {

  public catalogProgressList: Array<any> = new Array<any>();

  // テキストインプットインスタンス
  public catalogProgressTextInputComponent: CatalogProgressTextInputComponent;
  // コードリスト取得完了
  public completeUpdateList: boolean = <boolean>false;

  /**
   * 企画進捗管理情報リストアップデート
   *
   * @param serverData:サーバから取得された<Data>タグ
   */
  public updateCatalogProgressList(serverData: any): void {
    if (serverData == null) {
      this.catalogProgressList = new Array<any>();
      return;
    }
    this.catalogProgressList = serverData;
    this.completeUpdateList = true;

    this.catalogProgressTextInputComponent.changeOrderCodeHandler();
  }

}
